/// <reference path="../../app.definition.ts" />

import { InviteInfo } from "./InviteInfo";
import { Serializable } from "./Serializable";
import { User } from "./user";

export class SignUpResponse implements Serializable<SignUpResponse> {
  inviteInfo: InviteInfo;
  user: User;

  // this will be used for casting JSON to object
  deserialize(input) {
    if (!!input.inviteInfo) {
      this.inviteInfo = input.inviteInfo;
    }
    if (!!input.user) {
      this.user = new User().deserialize(input.user);
    }
    return this;
  }

  constructor() {
  }
}
